import { createContext } from 'react';
import {
  Contact,
  ContactLocationInfo,
  PatientInfo,
  PatientPreferencesResponse
} from '../../services/api-client/contact-api';
import { ILocation } from '../../services/location-service/location-service';
import { CareCreditPatientPrescreenInfo } from '../../types/payment/care-credit';

export interface PatientProfileContextProps {
  patientId: number | undefined;
  locationId: number;
  networkId: number;
  loadPatientDataById: (patientId: number) => Promise<void>;
  contactDetails: Contact;
  contactLocation: ILocation | undefined;
  contactLocationInfo: ContactLocationInfo[];
  loggedInUserLocation: ILocation | undefined;
  patientInfo: PatientInfo;
  patientPreferences: PatientPreferencesResponse;
  refreshPatientPreferences: () => Promise<void>;
  careCreditInfo: CareCreditPatientPrescreenInfo;
  isLoadingAlerts: boolean;
  showFormsForPatient: boolean;
}

export const PatientProfileContext = createContext<PatientProfileContextProps>(null!);
